import { render } from "./DetailOurTeam.vue?vue&type=template&id=c9e12c84&scoped=true"
import script from "./DetailOurTeam.vue?vue&type=script&lang=js"
export * from "./DetailOurTeam.vue?vue&type=script&lang=js"

import "./DetailOurTeam.vue?vue&type=style&index=0&id=c9e12c84&scoped=true&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9e12c84"]])

export default __exports__